import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LangToggle = ({ lang, setLang }) => (
  <div
    className="ml-auto flex items-center gap-1 rounded-[8px] border border-white/10 p-0.5"
    role="group"
    aria-label="Lingua / Language"
  >
    {[
      { code: "it", label: "IT" },
      { code: "en", label: "EN" },
    ].map((opt) => {
      const active = lang === opt.code;
      return (
        <button
          key={opt.code}
          type="button"
          onClick={() => setLang(opt.code)}
          data-testid={`legal-lang-${opt.code}`}
          aria-pressed={active}
          className={[
            "mono rounded-[6px] px-2.5 py-1 text-[11px] tracking-[0.08em] transition-colors duration-150",
            active
              ? "bg-[#00FF87]/15 text-[#00FF87]"
              : "text-white/40 hover:text-white/75",
          ].join(" ")}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export const LegalLayout = ({ title, updated, children, testid, lang, setLang }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-dvh bg-[#050508] text-white" data-testid={testid}>
      <header className="sticky top-0 z-10 flex items-center gap-3 border-b border-white/[0.06] bg-[#050508]/90 px-4 py-4 backdrop-blur-md">
        <button
          onClick={() => navigate(-1)}
          data-testid="legal-back-button"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[8px] border border-white/10 text-white/70 transition-colors hover:text-white"
          aria-label="Indietro / Back"
        >
          <ArrowLeft size={16} />
        </button>
        <div className="min-w-0">
          <p className="mono text-[14px] font-light tracking-[-0.01em] text-white">{title}</p>
          {updated && <p className="caps-tag text-white/30">{updated}</p>}
        </div>
        {setLang && <LangToggle lang={lang} setLang={setLang} />}
      </header>
      <main className="px-5 py-6 pb-24">
        <div className="prose-liqo space-y-5 text-[13px] font-light leading-[1.65] text-white/70">{children}</div>
      </main>
    </div>
  );
};

export const LegalH2 = ({ children }) => (
  <h2 className="mono mt-7 text-[13px] font-medium uppercase tracking-[0.12em] text-white/90">{children}</h2>
);

export const LegalP = ({ children }) => <p className="text-white/65">{children}</p>;

export const LegalUl = ({ items }) => (
  <ul className="list-disc space-y-1.5 pl-5 text-white/60 marker:text-[#00FF87]/60">
    {items.map((it) => (
      <li key={it}>{it}</li>
    ))}
  </ul>
);
